export const isWarmUp = (data) => {
    if (data.warmUp)
        return true;
    return false;
};
/**
 * The type of update to perform on a data object for different 'set' functions
 * such as `[cloud]/functions/src/groups/shifts/set/setShift.ts:setShift`
 */
export var SetDataUpdateType;
(function (SetDataUpdateType) {
    SetDataUpdateType["CREATE"] = "create";
    SetDataUpdateType["UPDATE"] = "update";
})(SetDataUpdateType || (SetDataUpdateType = {}));
//# sourceMappingURL=shared.js.map